<template>
    <el-dialog title="选择科目" append-to-body width="500px" class="ssseditcss" :visible.sync="dialogFormVisible">

        <div style="width: 100%;height: 100%;display:flex;flex-direction:column;">
            <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
                <el-tab-pane label="资产" name="ZC"></el-tab-pane>
                <el-tab-pane label="负债" name="FZ"></el-tab-pane>
                <el-tab-pane label="权益" name="QY"></el-tab-pane>
                <el-tab-pane label="成本" name="CB"></el-tab-pane>
                <el-tab-pane label="损益" name="SY"></el-tab-pane>
            </el-tabs>
        </div>

        <div class="ch_panel" id="queryDiv2" style="height: 400px; overflow: auto;">
            <div id="kmTree" class="ztree" style="background-color: white;"></div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate()">确 定</el-button>
        </div>

    </el-dialog>
</template>

<script>
    import $ from 'jquery'
    export default {
        data() {
            return {
                dialogFormVisible: true,
                activeName: 'ZC',
                defaultSetting: {
                    data: {
                        simpleData: {
                            enable: true
                        }
                    },
                    view: {
                        selectedMulti: false
                    }
                }
            };
        },
        methods: {
            int() {
                this.dialogFormVisible = true;
                this.getMgrTree("ZC");
            },
            getMgrTree(leiBie) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/dicKm/getMgrTree'),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        'leiBie': leiBie
                    })
                }).then(r => {
                    $("#kmTree").html("");
                    $.fn.zTree.init($("#kmTree"), this.defaultSetting, r.data.data);

                    //全部节点都要展开
                    let treeObj = $.fn.zTree.getZTreeObj("kmTree");
                    treeObj.expandAll(true);

                }).finally(r => {
                })
            },
            handleClick(tab) {
                //科目分类 ZC:资产、FZ:负债、QY:权益、CB:成本、SY:损益
                this.getMgrTree(tab.name);
            },
            addAndUpdate() {
                let treeObj = $.fn.zTree.getZTreeObj("kmTree");
                let nodes = treeObj.getSelectedNodes();
                if (nodes.length != 1) {
                    return '';
                }
                this.$emit("selectkmId", nodes[0]);
                this.dialogFormVisible = false;
            }
        }
    }
</script>

<style scoped>
    .ssseditcss >>> .el-dialog__body {
        padding: 10px 35px 25px 35px;
        top: 50%;
    }
</style>
